import React, { useState, useEffect } from "react"
import { GalleryVerticalEnd } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Link, useNavigate } from "react-router-dom"
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert"
import { useDispatch, useSelector } from "react-redux";
import { registerServiceRequest } from "@/services/auth/services";

export default function Register() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (submitted && !loading && !error) {
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
  }, [submitted, loading, error, navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
    if (errors[id]) {
      setErrors(prev => ({
        ...prev,
        [id]: ""
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "E-posta adresi gerekli";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Geçerli bir e-posta adresi girin";
    }
    if (!formData.password) {
      newErrors.password = "Parola gerekli";
    } else if (formData.password.length < 6) {
      newErrors.password = "Parola en az 6 karakter olmalı";
    }
    if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Parolalar eşleşmiyor";
    }
    if (!formData.first_name) {
      newErrors.first_name = "Ad gerekli";
    }
    if (!formData.last_name) {
      newErrors.last_name = "Soyad gerekli";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    dispatch(registerServiceRequest({
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirm_password,
      first_name: formData.first_name,
      last_name: formData.last_name,
    }));
    setSubmitted(true);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white shadow-lg rounded-lg">
        <div className="flex flex-col items-center gap-4 text-center mb-6">
          <div className="flex items-center gap-2 font-medium">
            <GalleryVerticalEnd className="size-5" />
            <span className="text-xl">sMPC</span>
          </div>
          <h1 className="text-2xl font-bold">Kayıt Ol</h1>
        </div>

        {error && submitted && !loading && (
          <p className="text-sm text-red-500 mb-2">Kayıt başarısız. Lütfen tekrar deneyin.</p>
        )}
        {submitted && !loading && !error && (
            <Alert variant="success">
              <AlertTitle>Başarılı</AlertTitle>
              <AlertDescription>
              Kayıt işleminiz başarıyla tamamlandı. Giriş sayfasına yönlendiriliyorsunuz...
              </AlertDescription>
            </Alert>
        )}

        {!submitted || loading ? (
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <div className="grid gap-3">
              <Label htmlFor="first_name">Ad</Label>
              <Input 
                id="first_name" 
                type="text" 
                placeholder="Adınız" 
                value={formData.first_name}
                onChange={handleChange}
                required 
              />
              {errors.first_name && <p className="text-sm text-red-500">{errors.first_name}</p>}
            </div>
            <div className="grid gap-3">
              <Label htmlFor="last_name">Soyad</Label>
              <Input 
                id="last_name" 
                type="text" 
                placeholder="Soyadınız" 
                value={formData.last_name}
                onChange={handleChange}
                required 
              />
              {errors.last_name && <p className="text-sm text-red-500">{errors.last_name}</p>}
            </div>
            <div className="grid gap-3">
              <Label htmlFor="email">Email</Label>
              <Input 
                id="email" 
                type="email" 
                placeholder="m@example.com" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
              {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}
            </div>
            <div className="grid gap-3">
              <Label htmlFor="password">Parola</Label>
              <Input 
                id="password" 
                type="password" 
                value={formData.password}
                onChange={handleChange}
                required 
              />
              {errors.password && <p className="text-sm text-red-500">{errors.password}</p>}
            </div>
            <div className="grid gap-3">
              <Label htmlFor="confirm_password">Parola Tekrarı</Label>
              <Input 
                id="confirm_password" 
                type="password" 
                value={formData.confirm_password}
                onChange={handleChange}
                required 
              />
              {errors.confirm_password && <p className="text-sm text-red-500">{errors.confirm_password}</p>}
            </div>
            <Button type="submit" variant="default" className="w-full" disabled={loading}>
              {loading ? "Kayıt Olunuyor..." : "Kayıt Ol"}
            </Button>
            <div className="text-center text-sm">
              Zaten bir hesabınız var mı?{" "}
              <Link to="/login" className="underline underline-offset-4">Giriş Yap</Link>
            </div>
          </form>
        ) : null}
      </div>
    </div>
  );
}
